var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.template},[_c('b-overlay',{style:(_vm.cssProps),attrs:{"show":!_vm.permission,"rounded":"lg","spinner-variant":"customer","id":"app"}},[(_vm.$auth.check())?[_c('div',{staticClass:"bg-global"},[_c('NavBar'),_c('Header'),_c('div',{staticClass:"pt-3"},[_c('router-view')],1),_c('Footer')],1)]:_c('router-view')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }